import { AlertTriangle } from 'lucide-react';
import BotAccessForm from '../../../../components/BotAccessForm';

export default function BotAccessFix({ domain, onFixApplied }) {
  return (
    <div className="space-y-4">
      <p className="text-sm text-ink-600">
        Toggle which AI crawlers you allow for{' '}
        <span className="font-medium text-ink-900">{domain.domain}</span>. Allowing a bot
        records the preference here; AI engines that respect this list will treat the
        domain as crawlable.
      </p>

      <BotAccessForm domainId={domain._id} onChange={onFixApplied} />

      <div className="flex items-start gap-2 bg-amber-50 border border-amber-100 rounded-xl p-3 text-xs text-amber-800">
        <AlertTriangle className="w-4 h-4 flex-none mt-0.5 text-amber-600" />
        <div>
          We re-check your <code className="px-1 bg-white border border-amber-100 rounded">robots.txt</code> on every audit. If your server still has{' '}
          <code className="px-1 bg-white border border-amber-100 rounded">Disallow:</code>{' '}
          rules for these bots, also remove those — toggling here alone won’t override
          what your robots.txt says publicly.
        </div>
      </div>
    </div>
  );
}
